import { LogoMark } from '../ui';

export function FullPageLoader({ label = 'Loading CertiHash' }: { label?: string }) {
  return (
    <div className="full-loader" role="status" aria-label={label}>
      <div className="full-loader__mark">
        <LogoMark size={40} />
      </div>
    </div>
  );
}
